import React from "react";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { TreatFrequency, TreatFrequencyMeta } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  value?: TreatFrequency | null;
  onChange: (frequency: TreatFrequency) => void;
};

const OPTIONS: ChoiceOption[] = [
  {
    value: TreatFrequency.HEAVY_SNACKER,
    label: TreatFrequencyMeta[TreatFrequency.HEAVY_SNACKER].label,
    sublabel: "Treats every day",
    icon: quizAsset("icon-treats-heavy"),
  },
  {
    value: TreatFrequency.OCCASIONAL,
    label: TreatFrequencyMeta[TreatFrequency.OCCASIONAL].label,
    sublabel: "A few times a week",
    icon: quizAsset("icon-treats-occasional"),
  },
  {
    value: TreatFrequency.NEVER,
    label: TreatFrequencyMeta[TreatFrequency.NEVER].label,
    sublabel: "No extra treats",
    icon: quizAsset("icon-treats-never"),
  },
];

export function TreatFrequencyQuestion({ dogName, value, onChange }: Props) {
  return (
    <QuestionCard
      title={`How often does ${dogName || "your dog"} get treats?`}
      subtitle="This helps us calculate the right portion size"
      subtitleAbove
      field="treatFrequency"
    >
      <QuizChoiceCard
        options={OPTIONS}
        selected={value ?? ""}
        onSelect={(v) => onChange(v as TreatFrequency)}
        size="sm"
      />
    </QuestionCard>
  );
}
